<div @slideInStagger>
	<div class="alert alert-danger mt-2" *ngIf="purchaseOrderBlocked?.length > 0">
    {{ 'to_generate.regulation_credit_note_waiting_alert'|translate }}
  </div>
  <div class="row mt-4 slide-in-animation">
    <div class="col-md-12">
      <table class="table table-material box-shadow-hover table-responsive-sm">
        <thead class="thead-normal">
        <tr>
          <th class="text-center">{{"to_generate.column.project"|translate}}</th>
          <th class="text-center">{{"to_generate.column.purchase_order"|translate}}</th>
          <th>{{"to_generate.column.client"|translate}}</th>
          <th class="text-center">{{"to_generate.column.action"|translate}}</th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let item of listContent; let i = index">
          <td class="text-center">
            {{ item.projectName }}
          </td>
          <td class="text-center">
          {{ item.purchaseOrderNumber }}
          </td>
          <td>
            {{ item.clientName }}
          </td>
          <td class="text-center">
            <isp-button
              class="px-1"
              [disabled]="purchaseOrderBlocked.includes(item.purchaseOrderNumber)"
              [type]="ButtonTypeEnum.ICON"
              [tooltip]="(!purchaseOrderBlocked.includes(item.purchaseOrderNumber) ? 'to_generate.button_generate':'to_generate.regulation_credit_note_waiting')|translate"
              [icon]="faPenToSquare"
              [colour]="IspColoursEnum.primary"
              (trigger)="!purchaseOrderBlocked.includes(item.purchaseOrderNumber) ? generateInvoice(item) : null"
              [size]="SizeEnum.xs"
            ></isp-button>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>


</div>
